// extracted by mini-css-extract-plugin
export default {"switch_container":"Switch_switch_container__Yrd6v","switch":"Switch_switch__NOh7d","slider":"Switch_slider__s60Ak","dark":"Switch_dark__mWTQg","light":"Switch_light__fTNHt"};